// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IpXI_15YtVe7PnDuxNMw{gap:4px;width:100%;display:flex}.v0Uead0TYDQ7q8gtsyEO{visibility:hidden;position:absolute}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `IpXI_15YtVe7PnDuxNMw`,
	"collection": `v0Uead0TYDQ7q8gtsyEO`
};
export default ___CSS_LOADER_EXPORT___;
